import { ChangeDetectionStrategy, Component, inject, Signal, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PenaltiesService } from '@fair-play/infra';
import {
  DashboardLocationMessageQueryHandler,
  DashboardProfileMessageQueryHandler,
  DashboardRedCardMessageQueryHandler,
  DashboardUpdateMessageQueryHandler
} from '../../application/handlers';
import { DashboardMessageQueryResult } from '../../application/models/dashboard-message.query-result';
import { DashboardMessagesViewService } from './view-service/dashboard-messages.view-service';

@Component({
  selector: 'lib-dashboard-messages',
  templateUrl: './dashboard-messages.component.html',
  styleUrls: ['./dashboard-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [
    DashboardMessagesViewService,
    DashboardUpdateMessageQueryHandler,
    DashboardProfileMessageQueryHandler,
    DashboardRedCardMessageQueryHandler,
    DashboardLocationMessageQueryHandler,
    PenaltiesService
  ]
})
export class DashboardMessagesComponent {
  private readonly viewService: DashboardMessagesViewService = inject(DashboardMessagesViewService);

  readonly messages: Signal<DashboardMessageQueryResult[]> = toSignal(this.viewService.messages$, {
    initialValue: []
  });

  onClick(message: DashboardMessageQueryResult): void {
    if (!message.clickable) {
      return;
    }
    this.viewService.onClick(message);
  }

  onDismiss(message: DashboardMessageQueryResult, event: Event): void {
    event.stopPropagation();
    this.viewService.onDismiss(message);
  }
}
